import React from "react";
import { bannerInfo } from "./VipJumbotronFunc";

const VipMaintenanceBulletin = ({ game_id, maintenanceBulletin }) => {
  
  const banner = bannerInfo(game_id);
  
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6  col-sm-12  mt-3">{banner}</div>
        <div className="col-lg-3 mt-3"> </div>
      </div>
      {maintenanceBulletin && (
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6  col-sm-12  mt-3">
        <div className="alert alert-danger" role="alert">
        <center>
        <p
          dangerouslySetInnerHTML={{
            __html: maintenanceBulletin
          }}
        />
        </center>
        </div>
        </div>
      </div>
      )}
    </div>
  );

};

export default VipMaintenanceBulletin;
